import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { radiologyQKeys } from "@hooks/queries/radiology/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  radId: string;
  fileName: string;
  patientId: string;
}

export const useDeleteRadiologyFile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ radId, fileName }: MutationProps) => {
      return api.delete(`radiology/${radId}/file/${fileName}`);
    },
    onSuccess: (res, variables) => {
      showSuccessNotification({
        title: "success",
        message: "delete-radiology-file-success",
      });
      if (!res.data.count) {
        queryClient.invalidateQueries({
          queryKey: radiologyQKeys.patient(variables.patientId),
        });
      }
    },

    onError: res => {
      console.error("[From Delete Radiology File]", res);

      handleErrors(res, "mutation");
    },
  });
};
